import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
  },
  title: {
    width: ({ provider, embedded }) => (provider || embedded ? 'unset' : 300),
    fontSize: 16,
    lineHeight: '18px',
    textAlign: 'center',
    paddingBottom: '15px',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'row',
    padding: '14px',
    border: '1px solid #ff8c691a',
    borderRadius: '20px',
    marginBottom: 25,
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
  },
  button: {
    width: ({ provider, embedded }) => (provider || embedded ? 'unset' : '280px'),
    minHeight: '50px',
    borderRadius: '20px',
    backgroundColor: '#FF8C69',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#fff4f1 !important',
      border: '1px solid #FF8C69',
      color: '#FF8C69',
    },
  },
  skipOnClick: {
    paddingTop: '50px',
    textDecorationLine: 'underline',
    textUnderlineOffset: '4px',
    paddingBottom: '1px',
    margin: '0 0 50px 0',
    cursor: 'pointer',
    [theme.breakpoints.down('xs')]: {
      margin: '0 auto',
      paddingTop: '0',
    },
  },
}));
